import React from 'react';
import { ConversationSummary } from '../goFormz-agent-types';
import OpenConversationIcon from '../../icons/OpenConversationIcon';
import TrashConversationIcon from '../../icons/TrashConversationIcon';
import AgentButton from './AgentButton';

export default function AgentConversationHistory({
  conversations,
  summarySelected,
  onDelete
}: {
  conversations: ConversationSummary[];
  summarySelected: (conversation: ConversationSummary) => void;
  onDelete: (conversation: ConversationSummary) => void;
}) {
  if (conversations.length === 0) {
    return <div className="history-empty">No conversations found.</div>;
  }

  return (
    <div className="ai-popup-history">
      {conversations.map((conversation) => (
        <div key={conversation.conversationSessionId} className="history-item-row">
          <div className="history-item">
            <div className="history-item-content">
              <div className="history-text">{conversation.firstMessage}</div>
            </div>
          </div>

          <div className="history-actions">
            <AgentButton onClick={() => summarySelected(conversation)}>
              <OpenConversationIcon />
            </AgentButton>
            <AgentButton onClick={() => onDelete(conversation)} aria-label="Delete conversation">
              <TrashConversationIcon />
            </AgentButton>
          </div>
        </div>
      ))}
    </div>
  );
}
